export const imgToSpan = (imgElement: HTMLImageElement, doc: Document) => {
  const srcUrl = imgElement.src;

  const spanElement = doc.createElement('span');

  Array.from(imgElement.attributes).forEach((attr) => {
    if (attr.name !== 'src') {
      spanElement.setAttribute(attr.name, attr.value);
    }
  });

  const computedStyle = window.getComputedStyle(imgElement);

  spanElement.style.width = computedStyle.width;
  spanElement.style.height = computedStyle.height;
  spanElement.style.display = 'inline-block';
  spanElement.style.backgroundImage = `url("${srcUrl}")`;
  spanElement.style.backgroundSize = '100% 100%';
  spanElement.style.backgroundRepeat = 'no-repeat';
  spanElement.style.backgroundPosition = 'center';
  spanElement.style.imageRendering = 'auto';

  return spanElement;
};
